// extracted by mini-css-extract-plugin
export default {"RootContent":"App_RootContent__rEYxf"};